export default __webpack_public_path__ + "static/1347-e72dca4e44e8382545b2bde5faaeded9.gif";